var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "288px",
    height: "273px",
    viewBox: "0 0 288 273",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5706 17.2649C19.9458 18.3407 19.5172 20.0478 18.6381 20.3674C16.4949 21.1547 13.7923 22.3162 11.9107 21.5756C5.71366 19.1514 1.3474 14.2482 0.0469609 7.20145C-0.309024 5.26826 1.43458 2.64131 2.72048 0.715914C3.18544 -0.0012362 5.5611 -0.26627 6.25854 0.326158C11.0316 4.48095 15.6667 8.82283 20.1347 13.3362C20.8321 14.03 20.4544 15.9242 20.5706 17.2649",
    transform: "matrix(-0.13917325 0.99026805 -0.99026805 -0.13917325 287.1914 3.0357666)",
    id: "Fill-261",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3834 7.18765C11.5061 10.3925 9.46417 13.3513 6.42898 14.8806C3.60354 16.3102 -0.184278 13.7237 0.00696375 9.85393C0.148853 7.08126 1.82684 4.38174 3.43697 0C6.58321 3.12506 9.51352 4.73414 10.3834 7.18765Z",
    transform: "translate(219.83594 257.07812)",
    id: "Fill-286",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98177 10.237C8.85774 11.0696 7.89941 12.2961 6.6276 12.5774C5.2931 12.885 2.82561 12.72 2.31062 12.0148C-0.215083 8.50787 -0.994289 4.69711 1.62546 0.890108C1.92997 0.443769 2.82561 -0.0550797 3.36747 0.00493223C4.83185 0.162463 6.82464 0.222475 7.58594 1.00638C10.1788 3.65816 10.7072 6.8913 9.98177 10.237",
    transform: "translate(0 23.519653)",
    id: "Fill-255",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.e710f5097c19b98c16c72798138747ac.svg";
export { ForwardRef as ReactComponent };